import React from "react";
import {GiFullPizza} from 'react-icons/gi'

const Header = () => {
  return (
    <header className="header-contenedor">
              <GiFullPizza className="pizza"/>
    </header>
  );
};

export { Header };
